import { useMatrixColumnsContext, useMatrixSettingsContext } from '@app/components/products/ProductMatrix/context';
import { cn } from '@app/utils/cn';
import { useMatrixLayout } from '@app/utils/hooks/matrix/useMatrixLayout';
import { useMatrixNavigation } from '@app/utils/hooks/matrix/useMatrixNavigation';
import { Position } from '@typings';
import React from 'react';

import { PinnableSummaryCell } from './PinnableSummaryCell';
import { RegularSummaryCell } from './RegularSummaryCell';

interface Props {
  position: Position;
  className?: string;
  wrapperClassName?: string;
}

export const RowSummaryCell = ({ children, position, className, wrapperClassName }: React.WithChildren<Props>) => {
  const { isFocused, isSelected, setFocusableElement, isFocusTarget } = useMatrixNavigation(position);
  const { isTotalsColumnPinned } = useMatrixColumnsContext();
  const { isDesktop } = useMatrixSettingsContext();
  const { hasMultipleColumns } = useMatrixLayout();

  return (
    <PinnableSummaryCell>
      <RegularSummaryCell
        wrapperClassName={cn(
          'bg-neutral-96 transition-colors border-white border-2 rounded-regular',
          {
            'sticky right-0': isTotalsColumnPinned,
            'w-[1%]': !isDesktop && hasMultipleColumns,
          },
          wrapperClassName,
        )}
        className={className}
        dataTestId={`matrixRowTotals-${position.y}`}
        isFocusTarget={isFocusTarget}
        isSelected={isFocused || isSelected}
        ref={setFocusableElement}
      >
        {children}
      </RegularSummaryCell>
    </PinnableSummaryCell>
  );
};
